/* eslint-disable no-magic-numbers */
import React, { useEffect, useLayoutEffect, useRef } from 'react';
import clsx from 'clsx';

import { ReportIntlProvider } from '../report-intl-provider/report-intl-provider';
import { ReportRenderer } from '../report-renderer/report-renderer';
import { useReportBuilderContext } from '../../report-builder.context';

import styles from './report-render-for-print.scss';

interface Props {
  currency: string;
}

export const ReportRenderForPrint = ({ currency }: Props) => {
  const reportViewRef = useRef<HTMLDivElement | null>(null);
  const workAreaRef = useRef<HTMLDivElement | null>(null);

  const {
    pageSetup: { orientation },
    allRequestsFinished,
    setWorkAreaWidth,
    locale
  } = useReportBuilderContext();

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (allRequestsFinished) {
      timer = setTimeout(() => {
        window.allRequestsFinished = true;
      }, 5000);
    }

    return () => clearTimeout(timer);
  }, [allRequestsFinished]);

  useLayoutEffect(() => {
    const updateWorkAreaWidth = () => {
      setWorkAreaWidth((workAreaRef.current?.clientWidth || 120) - 120);
    };
    updateWorkAreaWidth();

    window.addEventListener('resize', updateWorkAreaWidth);

    return () => {
      window.removeEventListener('resize', updateWorkAreaWidth);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workAreaRef.current?.clientWidth]);

  return (
    <div className={clsx(styles.viewContainer)} ref={workAreaRef} id="rendered-report">
      <ReportIntlProvider locale={locale}>
        <ReportRenderer
          isDashboard={orientation === 'dashboard'}
          printState={true}
          containerRef={reportViewRef}
          currency={currency}
        />
      </ReportIntlProvider>
    </div>
  );
};
